import React, { useEffect, useState } from 'react';

//Report Wrapper to fetch the report data from S3. Use this before rendering the controller or before the render of UI.
//To get the signed url from the server, use the query GET_SIGNED_URL
const ReportProvider = ({ signedUrl, ...props }) => {
  const [reportData, setReportData] = useState();
  const [reportLoading, setReportLoading] = useState(true);
  const [reportError, setReportError] = useState();

  useEffect(() => {
    if (signedUrl) {
      const s3Url = new URL(signedUrl);
      fetch(s3Url).then(async (response) => {
        if (response) {
          try {
            await response.json().then((json) => {
              setReportData(json);
              setReportLoading(false);
            });
          } catch (err) {
            console.log(err);
            setReportError(err);
            setReportLoading(false);
          }
        }
      });
    }
  }, [signedUrl]);

  return (
    <React.Fragment>
      {React.cloneElement(props.children, {
        ...props.children.props,
        reportData,
        reportLoading,
        reportError,
      })}
    </React.Fragment>
  );
};

export default ReportProvider;
